






















import Vue from "vue";

// Cannot use @tt-app alias for package.json
import PackageInfo from "../../../../package.json";
import GitInfo from "../../../../GitInfo.json";
import { TWAStatus } from "../../../constants/vuex/root";

const { NOT_TWA, NO_VERSION } = TWAStatus;

interface Props {
  commitHash: string;
  version: string;
}

interface Computed {
  androidAppVersion: string;
  iosAppVersion: string;
  isProductionEnv: boolean;
}

export default Vue.extend<{}, {}, Computed, Props>({
  name: "SettingsFooter",

  props: {
    commitHash: { type: String, default: (GitInfo as any)["commitHash"] },
    version: { type: String, default: (PackageInfo as any)["version"] }
  },

  computed: {
    androidAppVersion() {
      if (
        this.$store.state.androidAppVersion == NOT_TWA ||
        this.$store.state.androidAppVersion == NO_VERSION
      ) {
        return "";
      }
      return this.$store.state.androidAppVersion || "";
    },
    iosAppVersion() {
      return this.$store.state.iosAppVersion || "";
    },
    isProductionEnv() {
      return process.env.NODE_ENV === "production";
    }
  }
});
